import Vue from 'vue'
import App from './App.vue'
import firebase from 'firebase/app';
import router from './router'
import vuetify from './plugins/vuetify';
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'

// Your web app's Firebase configuration
var firebaseConfig = {
  apiKey: "AIzaSyDpZBcudlD0NPlhmEEZ3XkntTbcU4vuMRU",
  authDomain: "kampagne-smart-sales.firebaseapp.com",
  databaseURL: "https://kampagne-smart-sales.firebaseio.com",
  projectId: "kampagne-smart-sales",
  storageBucket: "kampagne-smart-sales.appspot.com",
  messagingSenderId: "1071591315194",
  appId: "1:1071591315194:web:e8f5d4cd551b73b75a1b43"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);

Vue.config.productionTip = false

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount('#app')
